export type LayoutOptions = {
  topImageOnPhone?: boolean;
};

/**
 * Parse layoutOptions.
 *
 * Layout options:
 *
 * - `top-image-on-phone` => options.topImageOnPhone
 *   [CodeOnly] Indicate that the image of the block should be displayed above the text when viewing on phones.
 *
 * "[CodeOnly]" means the option can be overriden in the source code only, and not declarable through Contentful.
 *
 * @param layoutOptions
 * @returns
 */
function parseLayoutOptions(layoutOptions?: Array<string>): LayoutOptions {
  const options: LayoutOptions = { topImageOnPhone: false };

  if (!layoutOptions) {
    return options;
  }

  for (const o of layoutOptions) {
    if (o === 'top-image-on-phone') {
      // CodeOnly option, show image on top on phone.
      // This is used for Testimonial module
      options.topImageOnPhone = true;
    }
  }
  return options;
}

export default parseLayoutOptions;
